import Validator, { type Validators } from '../../../form/Validator';

export const getValidationRules = (isQuickAddOrgFlow: boolean, allowMissingEmail = false): Validators => {
    const validationRules: Validators = {
        'name.firstName': [Validator.RULES.isRequired],
        'name.lastName': [Validator.RULES.isRequired],
        'contactInfo.email.address': allowMissingEmail
            ? [Validator.RULES.email]
            : [Validator.RULES.isRequired, Validator.RULES.email]
    };

    if (isQuickAddOrgFlow) {
        validationRules['contactInfo.phone.number'] = [Validator.RULES.phoneNumber];
    }
    return validationRules;
};
